import React from "react";
import { Star, ArrowUpRight } from "lucide-react";
import { Reveal } from "./motion";
import { REVIEW_RATING, REVIEW_COUNT } from "../lib/shop";

export const REVIEWS = [
  {
    quote: "The quality is unlike anything I've found on the high street. Truly a cut above. Every detail has been considered.",
    name: "Sarah M.", location: "London", product: "01 Signature Oversized Hoodie",
  },
  {
    quote: "Wasn't sure what to expect at first, but this hoodie exceeded it. The material is properly heavyweight — you can feel the difference straight away. I've had hoodies double the price that don't feel this good.",
    name: "Tyler", location: "Customer", product: "01 Signature Oversized Hoodie",
  },
  {
    quote: "Feels like a £100 hoodie easily. The material is thick and structured, and you can tell it's not cheap as soon as you put it on. Fit is perfect oversized.",
    name: "Jamie", location: "Customer", product: "01 Signature Oversized Hoodie",
  },
  {
    quote: "I love this brand and the products they sell. I have two oversized hoodies and they're great! True to size, great quality. They are organised, attentive to detail and delivery in a timely manner.",
    name: "Rebecca Hearn", location: "Customer", product: "01 Signature Oversized Hoodie",
  },
  {
    quote: "I've never received so many compliments on a piece of clothing. The fit is impeccable and the fabric feels extraordinary.",
    name: "James T.", location: "Edinburgh", product: "01 Signature Sweatshirt",
  },
  {
    quote: "From the packaging to the garment itself, everything speaks of care and craftsmanship. Worth every penny.",
    name: "Charlotte W.", location: "Manchester", product: "01 Signature Tee",
  },
];

function Stars({ className = "w-4 h-4" }) {
  return (
    <span className="flex text-amber-400 gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className={`${className} fill-current`} />
      ))}
    </span>
  );
}

export default function Reviews() {
  return (
    <section id="reviews" className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-36">
      <Reveal>
        <p className="font-mono text-[10px] md:text-xs tracking-[0.3em] text-ash uppercase mb-4">Worn. Rated. Repeated.</p>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <h2 className="font-display font-extrabold uppercase tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
            WHAT OUR<br />CUSTOMERS SAY
          </h2>
          <div className="flex items-center gap-4" data-testid="social-proof-rating-summary">
            <span className="font-display font-extrabold text-5xl">{REVIEW_RATING}</span>
            <div>
              <Stars />
              <p className="font-mono text-[10px] tracking-[0.16em] text-ash uppercase mt-1.5">{REVIEW_COUNT} reviews</p>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={i * 0.06} className="bg-ink">
            <figure className="p-8 h-full flex flex-col gap-5 hover:bg-card transition-colors duration-500" data-testid={`review-card-0${i + 1}`}>
              <Stars className="w-3.5 h-3.5" />
              <blockquote className="text-sm leading-relaxed text-bone/90 flex-1">"{r.quote}"</blockquote>
              <figcaption className="flex items-end justify-between gap-4 mt-auto">
                <div>
                  <p className="font-mono text-xs tracking-wider uppercase">{r.name}</p>
                  <p className="font-mono text-[10px] text-ash tracking-[0.12em] uppercase mt-1">{r.location} — {r.product}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-10 text-center">
        <a href="#faq" className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] text-ash hover:text-bone uppercase transition-colors">
          Sizing, shipping &amp; returns — everything you need to know <ArrowUpRight className="w-4 h-4" />
        </a>
      </Reveal>
    </section>
  );
}
